export const formatTime = (dateObj) => {
    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
};

export const formatTimeMinutes = (secs) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
};

export function formatDateOrEmpty(dateValue) {
    if (!dateValue || dateValue === "0001-01-01T00:00:00") return "";

    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return "";

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
}

export const sanitizeInput = (
    value,
    options = { allowNumbers: true, allowLetters: true, allowSpaces: true, allowPunctuation: false }
    ) => {
    if (!value) return "";

    let pattern = "";

    if (options.allowNumbers) pattern += "0-9";
    if (options.allowLetters) pattern += "a-zA-Z";
    if (options.allowSpaces) pattern += " ";
    if (options.allowPunctuation) pattern += ".,"; // Allow comma and period

    // Remove everything NOT in allowed pattern
    const regex = new RegExp(`[^${pattern}]`, "g");

    return value.replace(regex, "");
};

// Sanitize branding name - letters, numbers, hyphens, underscores
export const sanitizeBrandingName = (value) => {
  if (!value) return "";
  // Allow alphanumeric characters, hyphens, and underscores
  return value.replace(/[^a-zA-Z0-9_-]/g, "");
};

// Sanitize name fields - only letters and spaces (no numbers, no special characters)
export const sanitizeName = (value) => {
  if (!value) return "";
  // Allow only letters and spaces
  return value.replace(/[^a-zA-Z ]/g, "");
};

// Sanitize email - prevent @@ and .. patterns
export const sanitizeEmail = (value) => {
  if (!value) return "";
  // Remove @@ and .. patterns
  let sanitized = value.replace(/@@+/g, "@"); // Replace multiple @ with single @
  sanitized = sanitized.replace(/\.\.+/g, "."); // Replace multiple dots with single dot
  return sanitized;
};